import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import PropTypes from 'prop-types';

import Select from 'react-select';

import { Form } from 'react-bootstrap';
import AwpSpinner from '@components/Common/AwpSpinner';

import { STATE_STATUS } from '@awp/constants';
import { defaultSelectStyle } from '@awp/styleConstants';
import { isValueEmpty } from '@awp/helpers/utilsReact';

const Dropdown = ({ ...props }) => {
  const allOptions = useSelector(props.AllOptions);
  const currentValue = useSelector(props.CurrentValue);
  const dispatch = useDispatch();
  const [selectedValue, setSelectedValue] = useState(null);

  useMemo(() => {
    const foundOpt = allOptions.find((opt) => opt.Id == currentValue);
    if (!foundOpt) {
      setSelectedValue(null);
    } else {
      setSelectedValue({ value: foundOpt.Id, label: foundOpt.DropdownText });
    }
  }, [currentValue, allOptions]);

  const LoadingIndicator = () => {
    return (
      <div className="legend__loading">
        <AwpSpinner />
      </div>
    );
  };

  function handleChange(selOption) {
    dispatch(props.ChangeHandler(selOption.value));
  }

  return (
    <div>
      {!isValueEmpty(props.Title) ? (
        <Form.Label>
          <b>{props.Title}</b>
        </Form.Label>
      ) : null}
      <Select
        options={allOptions.map((opt) => {
          return { value: opt.Id, label: opt.DropdownText, isDisabled: opt.isDisabled };
        })}
        styles={defaultSelectStyle}
        setState={setSelectedValue}
        value={selectedValue}
        placeholder={!isValueEmpty(props.Placeholder) ? props.Placeholder : ''}
        onChange={handleChange}
        isLoading={props.LoadingStatus !== STATE_STATUS.SUCCESS}
        components={{ LoadingIndicator }}
      />
    </div>
  );
};

Dropdown.propTypes = {
  ChangeHandler: PropTypes.func.isRequired,
  AllOptions: PropTypes.func.isRequired,
  CurrentValue: PropTypes.any.isRequired,
  LoadingStatus: PropTypes.string.isRequired,
  Title: PropTypes.string,
  Placeholder: PropTypes.string,
};

export default Dropdown;
